<template>
  <div class="services-navigation pa-4">
    <v-divider class="mb-4" />
    
    <div class="d-flex justify-space-between align-center">
      <div class="text-body-2 text-grey">
        {{ selectedCount > 0 ? 
          t('employees.servicesSelectedMessage', { count: selectedCount }) : 
          t('employees.noServicesSelected') 
        }}
      </div>
      
      <div class="d-flex ga-3">
        <v-btn
          variant="text"
          @click="$emit('skip')"
        >
          {{ t('common.skip') }}
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :disabled="!canProceed"
          @click="$emit('continue')"
        >
          {{ isFinalStep ? t('common.complete') : t('common.continue') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  selectedCount: {
    type: Number,
    default: 0
  },
  canProceed: {
    type: Boolean,
    default: true
  },
  isFinalStep: {
    type: Boolean,
    default: false
  }
})

defineEmits<{
  'continue': []
  'skip': []
}>()

const { t } = useI18n()
</script>